// services/AccountsServices.js

import axiosInstance, { login as cookieLogin } from './axiosInstance';
import { getTenant } from '../utils/tenantUtils';

// Generate the base URL dynamically based on current hostname
const getTenantBaseUrl = () => {
  const tenant = getTenant();
  const baseApiUrl = process.env.REACT_APP_API_BASE_URL || '/api';
  if (tenant) {
    // For path-based routing: domain.com/$/tenant
    return `${baseApiUrl.replace('/api', '')}/$/${tenant}`;
  }
  // Fallback to base URL from env without '/api' suffix
  return baseApiUrl.replace('/api', '');
};

export const registerUser = async (formData) => {
  // Input validation
  if (!formData.username || !formData.password || !formData.email) {
    throw new Error('Missing required registration fields');
  }

  // Sanitize input
  const sanitizedData = {
    username: formData.username.trim(),
    email: formData.email.trim().toLowerCase(),
    password: formData.password
  };

  try {
    // Use the proper endpoint without duplicating /api/
    const response = await axiosInstance.post(`/register/`, sanitizedData);

    // Response validation
    if (!response.data || !response.data.id || !response.data.username) {
      throw new Error('Invalid registration response');
    }

    return response.data; // You can return the response data if needed
  } catch (error) {
    throw error; // Re-throw the error to handle it in the component
  }
};

export const loginUser = async (formData) => {
  if (!formData.username || !formData.password) {
    throw new Error('Missing required login credentials');
  }

  const sanitizedData = {
    username: formData.username.trim(),
    password: formData.password
  };

  // Delegate to axiosInstance.login: uses REACT_APP_API_BASE_URL (e.g. :8000) and
  // /$/tenant/ prefix. A relative fetch('/api/...') on CRA hits :3000 and 404s.
  return cookieLogin(sanitizedData);
};
